import { IActionFn, IPageData } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';
import store from '@/store';
import router from '@/plugins/router';

// 查询列表
export const queryMembers: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setMembers', { ...state.list, loading: true });
    const res: IPageData = await $http.post('/baseinfo/members', payload);
    commit('setMembers', { data: res.list, total: res.total, pageNum: res.pageNum, pageSize: res.pageSize });
  } catch (e) {
    commit('setMembers', { data: [], total: 0, pageNum: 0, pageSize: 0 });
  }
};

// 查询详情
export const queryMemberDetail: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setMemberDetail', { data: null, loading: true });
    const res = await $http.get(`/baseinfo/member/${payload}`);
    commit('setMemberDetail', { data: res });
  } catch (e) {
    commit('setMemberDetail', { data: null });
  }
};

// 查询会员类型
export const queryMemberTypes: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setMemberTypes', { ...state.types, loading: true });
    const res = await $http.get('/common/chooseoptions/MemberType', payload);
    commit('setMemberTypes', { data: res });
  } catch (e) {
    commit('setMemberTypes', { data: [] });
  }
};

// 查询组织类型
export const queryOrgTypes: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setOrgTypes', { ...state.orgTypes, loading: true });
    const res = await $http.get('/common/chooseoptions/OrgType', payload);
    commit('setOrgTypes', { data: res });
  } catch (e) {
    commit('setOrgTypes', { data: [] });
  }
};

// 添加会员
export const addMember: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post('/baseinfo/member/addbyplatform', payload);
    commit('setLoading', false);
    store.commit('common/setToast', { visible: true, text: '添加成功，2秒后跳转到列表页面' });
    await router.push({ name: 'org-member' });
  } catch (e) {
    commit('setLoading', false);
  }
};

// 编辑会员
export const editMember: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post('/baseinfo/member/modifybyplatform', payload);
  } finally {
    commit('setLoading', false);
  }
};

// 删除会员
export const deleteMember: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/baseinfo/member/delete', payload);
  } finally {
    commit('setConfirm', { visible: false, loading: false});
  }
};

// 锁定会员
export const lockMember: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/baseinfo/member/lock', payload);
  } finally {
    commit('setConfirm', { visible: false, loading: false});
  }
};

// 检查会员是否存在
export const checkMember: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setCheckResult', { exist: false, loading: true });
    const notExist: boolean = await $http.post('/check/member/notexisted', payload);
    commit('setCheckResult', { exist: !notExist, loading: false });
  } catch (e) {
    commit('setCheckResult', { exist: false, loading: false });
  }
};

// 会员升级为企业用户
export const adjustMember: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post('/baseinfo/organizationalserviceadjust', payload);
    commit('setLoading', false);
    store.commit('common/setToast', { visible: true, text: '升级成功，2秒后跳转到列表页面' });
    await router.push({ name: 'org-member' });
  } catch (e) {
    commit('setLoading', false);
  }
};

// 查询密码重置日志
export const queryResetLogs: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setResetLogs', { data: [], loading: true });
    const res = await $http.post('/baseinfo/member/update/log/search', payload);
    commit('setResetLogs', { data: res });
  } catch (e) {
    commit('setResetLogs', { data: [] });
  }
};

// 重置会员密码
export const resetMember: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/baseinfo/member/reset/password', payload);
  } finally {
    commit('setConfirm', { visible: false, loading: false });
  }
};
